export const config = {
  portfolio: {
    portfolioLogo: 'Portfolio',
    projectCard: {
      cards: [
        {
    heading: 'Google-clone project on Next.js',
    description: [
      'Google-clone with voice recognition, Google sign-in,',
      'Used Redux Toolkit, Redux Persist, and Tailwind CSS for a seamless experience.',
      'Excited to dive into more Next.js adventures!'
    ],
           animationDelay: '300',
          buttonLink: 'https://google-clone-nextjs-beta.vercel.app/',
          buttonText: 'CHECK OUT'
  },
				{
				 heading: 'Real Estate Project on MERN Stack',
  description: [
    'Features include OTP login via phone and Google, favorites, and advanced filtering.',
    'Utilized Redux, Redux Toolkit, Firebase for authentication & cloud storage.',
    'Backend implemented in Node.js with JWT web token.',
    'Hosted on Render.'
  ],

					animationDelay: '500',
          buttonLink: 'https://real-eastate.onrender.com/',
          buttonText: 'CHECK OUT',
				},
        {
          heading: 'Ecommerce in MERN',
          description: [
            'Developed an eCommerce clone using the MERN (MongoDB, Express.js, React, Node.js) stack.',
            ' Implemented a seamless add-to-cart feature that allows users to easily add products to their shopping cart.',
            ' Integrated a secure payment gateway to facilitate smooth and reliable online transactions.',
          ],
          animationDelay: '300',
          buttonLink: 'https://mushy-drawers-mite.cyclic.app/',
          buttonText: 'CHECK OUT',
        },
        {
          heading: 'Portfolio in REACT',
          description:
            'PortFolio with react and use scss for styling ',
          animationDelay: '500',
          buttonLink: 'https://main--venerable-lollipop-f127cf.netlify.app/',
          buttonText: 'CHECK OUT',
        },
        {
          heading: 'Youtube Clone in REACT',
          description: 'youtube Clone in React with searching and routing features in ',
          animationDelay: '700',
          buttonLink: 'https://www.loom.com/share/03a326fcb0014f199f233df5d1eae806',
          buttonText: 'CHECK OUT',
        },
        // {
        //   heading: 'Project Name Here',
        //   description:
        //     'Project description. Lorem ipsum dolor, sit amet consectetur adipisicing elit. Architecto mollitia at, neque iste, cupiditate distinctio ipsam animi iure nam inventore eos illo officiis voluptatibus labore est nulla totam magni minima blanditiis,',
        //   animationDelay: '900',
        //   buttonLink: 'https://google.com/',
        //   buttonText: 'CHECK OUT',
        // },
        {
          heading: 'Under Construction',
          description: '</>',
          animationDelay: '1100',
          buttonText: '',
        },
      ],
    },
    internships: {
      internship: [
        {
          companyName: 'Company Name',
          role: 'Front-end Developer',
          introText: '',
          duration: '29/03/2022 - 29/05/2022',
          keyPointOne: 'Built front-end of multiple website using ReactJS',
          keyPointTwo:
            'Add few lines here....',
          keyPointThree: 'Add few lines here... if requried Lorem, ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis voluptas dolo Perspiciatis voluptas do.',
          keyPointFour:
            'Add few lines here... if requried Lorem, ipsum dolor sit amet consectetur adipisicing architecto molestiae.',
          offsetValue: '0',
        },
        {
          companyName: 'Company Name',
          role: 'Front-end Developer',
          introText: '',
          duration: '14/06/2021 - 14/07/2021',
          keyPointOne: 'Built front-end of multiple website using ReactJS.',
          keyPointTwo: 'Add few lines here... if requried',
          keyPointThree:
            'Add few lines here... if requried',
          keyPointFour:
            'Add few lines here... if requried Lorem, ipsum dolor sit amet consectetur adipisicing cto molestiae.',
          offsetValue: '-1000',
        },
        {
          companyName: 'Company Name',
          role: 'Front-end Developer',
          introText: '',
          duration: '10/09/2020 - 10/11/2020',
          keyPointOne:
            'Add few lines here... if requried',
          keyPointTwo: 'Add few lines here... if requried',
          keyPointThree: 'Add few lines here... if requried',
          keyPointFour: '',
          offsetValue: '-1000',
        },
      ],
    },
  },
};

export default config;
